import {Route} from "./route";
import {EmbeddedPendingComponent} from "~/components/routerHelpers/embeddedPendingComponent";

export function PendingComponent() {
    return (
        <EmbeddedPendingComponent
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            route={Route as any}
        //
        />
    );
}
